<div class="right-sidebar-component">
  <div class="arrow-down-open"></div>
  <div class="right-sidebar-component__header">
    <vnc-header (onLeftIconClick)="closeSidebar()" style="width:100%;" size="l" title="{{ 'PROFILE' | translate }}"
    [iconTemplate]="backIconTemplate" type="back"></vnc-header>
    <ng-template #backIconTemplate>
      <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20z" fill="#000" fill-rule="evenodd"/>
      </svg>

    </ng-template>
  </div>
  <div class="right-sidebar-component__info">
    <div class="contact-avatar">
      @if (contact?.email === currentUser?.email) {
        <div class="edit-button-header">
          <button class="edit-button" matFab (click)="openCropperDialog()"   matTooltip="{{ 'EDIT_AVATAR' | translate }}">
            <svg width="18px" height="18px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <g id="Icon/product/edit" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="Icon-24px" transform="translate(3.000000, 2.997500)" fill="#ffffff">
                  <path d="M0,14.2525 L0,18.0025 L3.75,18.0025 L14.81,6.9425 L11.06,3.1925 L0,14.2525 L0,14.2525 Z M17.71,4.0425 C18.1,3.6525 18.1,3.0225 17.71,2.6325 L15.37,0.2925 C14.98,-0.0975 14.35,-0.0975 13.96,0.2925 L12.13,2.1225 L15.88,5.8725 L17.71,4.0425 L17.71,4.0425 Z" id="Shape"></path>
                </g>
              </g>
            </svg>
          </button>
        </div>
      }
      <!-- <vp-avatar [type]="'big-profile'" [user]="contact"> </vp-avatar> -->
      <vp-avatar [jid]="contact?.jid || contact?.email" [avatarId]="contact.user_id ? contact.user_id : contact.author_jid " [type]="'big-profile'" [user]="{ name: fullName ? fullName : '', avatarURL: contact.avatar }"></vp-avatar>
    </div>
    <div class="contact-info">
      <div class="contact-info__name">{{ fullName }}</div>
      <div class="contact-info__role">{{ contact?.job_title }}</div>
    </div>

  </div>
  <div class="right-sidebar-component__tabs">
    <vnc-profile [translation]="translations" profileLabel="{{ 'PROFILE' | translate }}" hrLabel="{{ 'HR_DATA' | translate }}"
      accountLabel="{{ 'ACCOUNT' | translate }}" activityLabel="{{ 'ACTIVITY' | translate }}"
      (onCopy)="copyEmail($event)"
      (openURL)="openURL($event)"
      [hideAudio]="contact?.email === currentUser?.email"
      [hideEmail]="contact?.email === currentUser?.email"
      [hideVideo]="contact?.email === currentUser?.email"
      [hideChat]="contact?.email === currentUser?.email"
      (profileAction)="handleProfileAction($event)"
      [activityTemplate]="activityTemplate" [hideFiles]="true" [hideChatInfo]="true"
    [maxTabs]="isLargeScreen ? 3 : 2" [alignActionCenter]="true" [profile]="contact"></vnc-profile>
  </div>
</div>

<ng-template #activityTemplate>
  <div class="detail-contact ">
    <div class="recent-activity">
      <div class="search-talk-mail">
        <vnc-input [showClear]="true" [disableAutoFocus]="true" [focused]="false" leadingIconName="mdi-magnify"
        placeholder="{{ 'SEARCH' | translate }}" [form]="searchControl" ></vnc-input>
      </div>
      <div class="chips-container">
        <vnc-chips (clickEvent)="isActiveIndex(0)" text="{{ 'ALL' | translate}}" [active]="activeIndex === 0" type="static" size="s"></vnc-chips>
        <vnc-chips (clickEvent)="isActiveIndex(1)" text="{{ 'CHATS' | translate}}" [active]="activeIndex === 1" type="static" size="s"></vnc-chips>
        <vnc-chips (clickEvent)="isActiveIndex(2)" text="{{ 'EMAIL' | translate}}" [active]="activeIndex === 2" type="static" size="s"></vnc-chips>
      </div>

      <mat-tab-group (selectedTabChange)="onSelectedTabChangeActivity($event)">
        <mat-tab label="{{ 'CHATS' | translate }}">
          <div class="recent-contact-tab">
            @if (!!searchResponse && searchResponse.docs?.length > 0) {
              <div class="recent-items">
                @for (item of searchResponse.docs; track item) {
                  <div class="recent-item" (click)="openRecentActivity(item)">
                    @if (item.type === 'talk' && !!item.chatType && item.chatType === 'chat') {
                      <span>
                        <div class="recen-item-inner">
                          <div class="left">
                            <div class="avatar-item">
                              <vp-avatar [jid]="item?.from" [avatarId]="item.from ? item?.from : item?.from " [user]="{ name: item.from ? item.from : '', avatarURL: getAvatarURL(item.from) }"></vp-avatar>
                            </div>
                          </div>
                          <div class="right">
                            <div class="title">
                              @if (!item.fileType || item.fileType === '') {
                                <span class="title-content">{{ item.contentTxt}}</span>
                              }
                              @if (item.fileType) {
                                <span>
                                  @if (item.fileType === 'image') {
                                    <ng-container [ngTemplateOutlet]="imageIcon"></ng-container>
                                  }
                                  @if (item.fileType === 'image') {
                                    <lable>{{'IMAGE' | translate }}</lable>
                                  }
                                  @if (item.fileType === 'audio') {
                                    <ng-container [ngTemplateOutlet]="audioIcon"></ng-container>
                                  }
                                  @if (item.fileType === 'audio') {
                                    <lable>{{'AUDIO' | translate }}</lable>
                                  }
                                  @if (item.fileType === 'video') {
                                    <ng-container [ngTemplateOutlet]="videoIcon"></ng-container>
                                  }
                                  @if (item.fileType === 'video') {
                                    <lable>{{'VIDEO' | translate }}</lable>
                                  }
                                  @if (item.fileType === 'doc') {
                                    <ng-container [ngTemplateOutlet]="docIcon"></ng-container>
                                  }
                                  @if (item.fileType === 'doc') {
                                    <lable>{{'DOC' | translate }}</lable>
                                  }
                                </span>
                              }
                              <span class="item-type"> •
                                @if (item.type === 'talk' && !!item.chatType && item.chatType === 'chat') {
                                  <span>
                                    <ng-container [ngTemplateOutlet]="chatIcon"></ng-container>
                                    {{'CHAT_LEBALE' | translate }}
                                  </span>
                                }
                              </span>
                            </div>
                            <div class="time">
                              {{ getDateWithFormat(item.createdDt , "dd MMM y") }} <span class="time-hours"> • {{ getDateWithFormat(item.createdDt , "hh:mm a") }}</span>
                            </div>
                          </div>
                        </div>
                        <mat-divider></mat-divider>
                      </span>
                    }
                    @if (item.type === 'mail') {
                      <span>
                        <div class="recen-item-inner">
                          <div class="left">
                            <div class="avatar-item">
                              <vp-avatar [jid]="item?.from" [avatarId]="item.from ? item?.from : item?.from " [user]="{ name: item.from ? item.from : '', avatarURL: getAvatarURL(item.from) }"></vp-avatar>
                            </div>
                          </div>
                          <div class="right">
                            <div class="title">
                              <span class="title-content">{{ item.title}}</span>
                              <span class="item-type"> •
                                @if (item.type === 'mail') {
                                  <span>
                                    <ng-container [ngTemplateOutlet]="mailIcon"></ng-container>
                                    {{ 'EMAIL_LBL' | translate }}
                                  </span>
                                }
                              </span>
                            </div>
                            <div class="time">
                              {{ getDateWithFormat(item.createdDt , "dd MMM y") }} <span class="time-hours"> • {{ getDateWithFormat(item.createdDt , "hh:mm a") }}</span>
                            </div>
                          </div>
                        </div>
                        <mat-divider></mat-divider>
                      </span>
                    }
                  </div>
                }
              </div>
            }
            @if (!searchResponse?.loading && (!searchResponse || !searchResponse.docs || searchResponse.docs?.length === 0)) {
              <div class="no-data-message">
                <div class="no-data-text">{{ 'NO_DATA_TO_DISPLAY' | translate }}</div>
              </div>
            }
          </div>
        </mat-tab>
        <mat-tab label="{{ 'EMAILS' | translate }}">
          <div class="recent-contact-tab">
            @if (!!searchResponse && searchResponse?.docs?.length > 0) {
              <div class="recent-items">
                @for (item of searchResponse.docs; track item) {
                  <div class="recent-item" (click)="openRecentActivity(item)">
                    @if (item.type === 'mail') {
                      <span>
                        <div class="recen-item-inner">
                          <div class="left">
                            <div class="avatar-item">
                              <vp-avatar [jid]="item?.from" [avatarId]="item.from ? item?.from : item?.from " [user]="{ name: item.from ? item.from : '', avatarURL: getAvatarURL(item.from) }"></vp-avatar>
                            </div>
                          </div>
                          <div class="right">
                            <div class="title">
                              <span class="title-content">{{ item.title}}</span>
                              <span class="item-type"> •
                                @if (item.type === 'mail') {
                                  <span>
                                    <ng-container [ngTemplateOutlet]="mailIcon"></ng-container>
                                    {{ 'EMAIL_LBL' | translate }}
                                  </span>
                                }
                              </span>
                            </div>
                            <div class="time">
                              {{ getDateWithFormat(item.createdDt , "dd MMM y") }} <span class="time-hours"> • {{ getDateWithFormat(item.createdDt , "hh:mm a") }}</span>
                            </div>
                          </div>
                        </div>
                        <mat-divider></mat-divider>
                      </span>
                    }
                  </div>
                }
              </div>
            }
            @if (!searchResponse?.loading && (!searchResponse || !searchResponse.docs || searchResponse.docs?.length === 0)) {
              <div class="no-data-message">
                <div class="no-data-text">
                  {{ 'NO_DATA_TO_DISPLAY' | translate }}
                </div>
              </div>
            }
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</ng-template>


<ng-template #chatIcon>
  <svg width="16px" height="16px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Icon/product/chats-empty-new" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <path d="M17.984375,3.015625 C20.1265704,3.015625 21.8754539,4.69959347 21.9794797,6.81598466 L21.984375,7.015625 L21.984375,15 C21.984375,17.1421954 20.3004065,18.8910789 18.1840153,18.9951047 L17.984375,19 L6,19 L3.72273178,21.2772682 C3.5351954,21.4648046 3.28084149,21.5701614 3.015625,21.5701614 C2.50278916,21.5701614 2.08011784,21.1841212 2.02235273,20.6867826 L2.015625,20.5701614 L2.015625,7.015625 C2.015625,4.87342961 3.69959347,3.12454612 5.81598466,3.02052031 L6.015625,3.015625 L17.984375,3.015625 Z M17.984375,5.015625 L6.015625,5.015625 C4.9612632,5.015625 4.09745988,5.83150279 4.02111074,6.86636266 L4.015625,7.015625 L4.015,18.155 L5.17157288,17 L17.984375,17 C19.0387368,17 19.9025401,16.1841222 19.9788893,15.1492623 L19.984375,15 L19.984375,7.015625 C19.984375,5.9612632 19.1684972,5.09745988 18.1336373,5.02111074 L17.984375,5.015625 Z" id="Combined-Shape" fill="#8B96A0"></path>
    </g>
  </svg>
</ng-template>

<ng-template #mailIcon>
  <svg width="16px" height="16px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Icon/product/mail-new" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <path
        d="M19,4 C20.6568542,4 22,5.34314575 22,7 L22,17 C22,18.6568542 20.6568542,20 19,20 L5,20 C3.34314575,20 2,18.6568542 2,17 L2,7 C2,5.34314575 3.34314575,4 5,4 L19,4 Z M19.7744108,6.3672689 L14.1213203,12.0208153 C12.9497475,13.1923882 11.0502525,13.1923882 9.87867966,12.0208153 L4.22558922,6.3672689 C4.10776024,6.51131027 4.0293244,6.68882894 4.00672773,6.88337887 L4,7 L4,17 C4,17.5128358 4.38604019,17.9355072 4.88337887,17.9932723 L5,18 L19,18 C19.5128358,18 19.9355072,17.6139598 19.9932723,17.1166211 L20,17 L20,7 C20,6.75993895 19.91541,6.53963495 19.7744108,6.3672689 Z M17.314,6 L6.685,6 L11.2928932,10.6066017 C11.6555229,10.9692314 12.2273683,10.9951335 12.619886,10.6843081 L12.7071068,10.6066017 L17.314,6 Z"
      id="Combined-Shape" fill="#8B96A0"></path>
    </g>
  </svg>
</ng-template>

<ng-template #imageIcon>
  <svg width="14px" height="14px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Icon/product/img-new" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <path
        d="M19,3.5 C20.6568542,3.5 22,4.84314575 22,6.5 L22,6.5 L22,18.5 C22,20.1568542 20.6568542,21.5 19,21.5 L19,21.5 L5,21.5 C3.34314575,21.5 2,20.1568542 2,18.5 L2,18.5 L2,6.5 C2,4.84314575 3.34314575,3.5 5,3.5 L5,3.5 Z M15.121,12.756 L11.7452122,17.3218537 C11.4357207,17.7403706 10.8629658,17.846786 10.4275814,17.5854256 L10.329729,17.5185577 L7.916,15.654 L4.88337887,19.4932723 L4.88337887,19.4932723 L5,19.5 L19,19.5 C19.0439873,19.5 19.0873112,19.4971599 19.1297985,19.4916531 L15.121,12.756 Z M19,5.5 L5,5.5 C4.44771525,5.5 4,5.94771525 4,6.5 L4,6.5 L4,17.394 L6.99595535,13.6331785 C7.3137239,13.2512143 7.85795191,13.1646884 8.2747999,13.4125012 L8.37615338,13.4814423 L10.744,15.311 L14.3724349,10.405419 C14.76186,9.87881006 15.5321201,9.86919209 15.9396018,10.353342 L16.0160407,10.4567487 L20,17.064 L20,6.5 C20,5.98716416 19.6139598,5.56449284 19.1166211,5.50672773 L19,5.5 Z"
      id="Combined-Shape" fill="#8B96A0"></path>
    </g>
  </svg>
</ng-template>

<ng-template #audioIcon>
  <svg width="14px" height="14px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Icon/product/audiotrack" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="Icon-24px" transform="translate(6.000000, 3.000000)" fill="#8B96A0">
        <path d="M6,0 L6,9.28 C5.53,9.11 5.03,9 4.5,9 C2.01,9 0,11.01 0,13.5 C0,15.99 2.01,18 4.5,18 C6.81,18 8.7,16.25 8.95,14 L9,14 L9,3 L13,3 L13,0 L6,0 L6,0 Z" id="Shape"></path>
      </g>
    </g>
  </svg>
</ng-template>
<ng-template #videoIcon>
  <svg width="18px" height="18px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Icon/product/notification-video" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="Icon/custom/video" transform="translate(3.750000, 6.750000)" fill="#8B96A0">
        <path
          d="M8.25,0 C9.85664654,0 11.1683092,1.26297635 11.2463285,2.85026974 L11.25,3 L11.25,7.5 C11.25,9.10664654 9.98702365,10.4183092 8.39973026,10.4963285 L8.25,10.5 L3,10.5 C1.39335346,10.5 0.081690843,9.23702365 0.00367148043,7.64973026 L0,7.5 L0,3 C0,1.39335346 1.26297635,0.081690843 2.85026974,0.00367148043 L3,0 L8.25,0 Z M8.25,1.5 L3,1.5 C2.20922865,1.5 1.56137616,2.11190834 1.5041143,2.88805324 L1.5,3 L1.5,7.5 C1.5,8.29077135 2.11190834,8.93862384 2.88805324,8.9958857 L3,9 L8.25,9 C9.04077135,9 9.68862384,8.38809166 9.7458857,7.61194676 L9.75,7.5 L9.75,3 C9.75,2.20922865 9.13809166,1.56137616 8.36194676,1.5041143 L8.25,1.5 Z M14.6569377,2.02656107 C15.3108012,1.58856487 16.1959283,1.76355985 16.6339245,2.41742329 C16.7342489,2.56719278 16.8049413,2.73417248 16.8448318,2.93198112 L16.8689561,3.08633083 L16.875,3.21048557 L16.875,7.28898084 C16.875,8.07598661 16.2370058,8.71398084 15.45,8.71398084 C15.269769,8.71398084 15.0917293,8.67979708 14.9052147,8.60288056 L14.7635731,8.5370472 L14.6570727,8.47299572 L12.6320727,7.11686595 C12.322532,6.90956848 12.1084081,6.59076132 12.0283131,6.19693761 L12.0066318,6.06293471 L12,5.93285106 L12,4.5669497 C12,4.19445217 12.145711,3.8391805 12.4283073,3.55349912 L12.5275638,3.46092124 L12.6319377,3.3830252 L14.6569377,2.02656107 Z M15.375,7.1505 L15.37575,3.3495 L13.5,4.605 L13.4985,5.892 L15.375,7.1505 Z"
        id="Combined-Shape"></path>
      </g>
    </g>
  </svg>
</ng-template>

<ng-template #docIcon>
  <svg width="14px" height="14px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Icon/product/file-markupcode" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <path
        d="M18.984375,21 C19.546875,21 20.0234375,20.8046875 20.4140625,20.4140625 C20.8046875,20.0234375 21,19.546875 21,18.984375 L21,18.984375 L21,5.015625 C21,4.453125 20.8046875,3.9765625 20.4140625,3.5859375 C20.0234375,3.1953125 19.546875,3 18.984375,3 L18.984375,3 L5.015625,3 C4.453125,3 3.9765625,3.1953125 3.5859375,3.5859375 C3.1953125,3.9765625 3,4.453125 3,5.015625 L3,5.015625 L3,18.984375 C3,19.546875 3.1875,20.0234375 3.5625,20.4140625 C3.9375,20.8046875 4.421875,21 5.015625,21 L5.015625,21 L18.984375,21 Z M9.984375,18 L6,18 L6,6 L9.984375,6 L9.984375,8.015625 L8.015625,8.015625 L8.015625,15.984375 L9.984375,15.984375 L9.984375,18 Z M18,18 L14.015625,18 L14.015625,15.984375 L15.984375,15.984375 L15.984375,8.015625 L14.015625,8.015625 L14.015625,6 L18,6 L18,18 Z"
      id="shape" fill="#8B96A0"></path>
    </g>
  </svg>

</ng-template>


